export default __webpack_public_path__ + "static/portraitCards_overland-eab83551b3ab1cbae8e95d4e29f5cc47.png";